// extracted by mini-css-extract-plugin
export default {"container":"change-user-goups__container--cF8A7","info":"change-user-goups__info--oALij"};